export default __webpack_public_path__ + "static/palettteapp-e20e6441ac3f6dbbf0c2b3ebdbf5756c.jpg";